export const CHAT_TYPES = {
  P2P: "P2P",
  ROUNDTABLE: "ROUNDTABLE",
  ASSISTANT: "ASSISTANT",
} as const;
